import { UPDATE_PROJECT_RECORD } from 'root/src/client/logic/project/actionIds'

export default payload => ({
	type: UPDATE_PROJECT_RECORD,
	payload,
})
